
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    editMode: { type: Boolean, default: false }
  },
  emits: ['createFolderClicked', 'switchEditModeClicked']
})
